import { IconProps } from "./types";

export default function IcoVehicleTruck({
	color = "#9CA3AF",
	width = "22.5",
	height = "18"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 19"
			fill="none"
		>
			<g clipPath="url(#clip0_639_977)">
				<path
					d="M2.4375 0.25C1.50586 0.25 0.75 1.00586 0.75 1.9375V13.1875C0.75 14.1191 1.50586 14.875 2.4375 14.875H3C3 16.7383 4.51172 18.25 6.375 18.25C8.23828 18.25 9.75 16.7383 9.75 14.875H14.25C14.25 16.7383 15.7617 18.25 17.625 18.25C19.4883 18.25 21 16.7383 21 14.875H22.125C22.7473 14.875 23.25 14.3723 23.25 13.75C23.25 13.1277 22.7473 12.625 22.125 12.625V10.375V9.25V8.59258C22.125 7.99492 21.8895 7.42188 21.4676 7L18.75 4.28242C18.3281 3.86055 17.7551 3.625 17.1574 3.625H15.375V1.9375C15.375 1.00586 14.6191 0.25 13.6875 0.25H2.4375ZM15.375 5.875H17.1574L19.875 8.59258V9.25H15.375V5.875ZM4.6875 14.875C4.6875 14.4274 4.86529 13.9982 5.18176 13.6818C5.49823 13.3653 5.92745 13.1875 6.375 13.1875C6.82255 13.1875 7.25178 13.3653 7.56824 13.6818C7.88471 13.9982 8.0625 14.4274 8.0625 14.875C8.0625 15.3226 7.88471 15.7518 7.56824 16.0682C7.25178 16.3847 6.82255 16.5625 6.375 16.5625C5.92745 16.5625 5.49823 16.3847 5.18176 16.0682C4.86529 15.7518 4.6875 15.3226 4.6875 14.875ZM17.625 13.1875C18.0726 13.1875 18.5018 13.3653 18.8182 13.6818C19.1347 13.9982 19.3125 14.4274 19.3125 14.875C19.3125 15.3226 19.1347 15.7518 18.8182 16.0682C18.5018 16.3847 18.0726 16.5625 17.625 16.5625C17.1774 16.5625 16.7482 16.3847 16.4318 16.0682C16.1153 15.7518 15.9375 15.3226 15.9375 14.875C15.9375 14.4274 16.1153 13.9982 16.4318 13.6818C16.7482 13.3653 17.1774 13.1875 17.625 13.1875Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_639_977">
					<path d="M0.75 0.25H23.25V18.25H0.75V0.25Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
